'use client'

import { getInsightsHref } from '@/components/links/insights'
import { ArticleFilter } from '@/entities/article'
import InsightsRoute from '@/lib/routes/insights'
import { toSlug } from '@/lib/url'
import { cn } from '@utils'
import { map } from 'lodash-es'
import { useRouter } from 'next/navigation'
import { useMemo, useState } from 'react'
import { useInsightsContext } from '../../context'

export default function InsightsTagsContent({ data }: { data: ArticleFilter }) {
  const { tagsOptions } = getOptions(data)

  const { query } = useInsightsContext()
  const defaultTag = useMemo(() => {
    if (!query) {
      return null
    }
    const route = new InsightsRoute()
    route.fromSlug(query)
    return route.toQuery().tag || null
  }, [query])

  const [currentTag, setCurrentTag] = useState<string | null>(defaultTag)
  const router = useRouter()

  function handleClick(data: { label: string; value: string }) {
    const isClear = data.value === currentTag
    setCurrentTag(isClear ? null : data.value)
    const route = new InsightsRoute()
    if (!isClear) {
      route.setVal('tag', toSlug(data.label, data.value))
    }
    router.push(getInsightsHref(route.getSlug()), {
      scroll: false,
    })
  }

  return (
    <section className='section border-b border-secondary/20 py-6 flex items-center flex-wrap gap-x-2 lg:gap-x-4'>
      <span className='text-lg font-bold'>Tags:</span>
      {map(tagsOptions, (item) => (
        <Item
          active={currentTag === item.value}
          data={item}
          onClick={handleClick}
          key={item.value}
        >
          {item.label}
        </Item>
      ))}
    </section>
  )
}

function Item({
  children,
  active,
  data,
  onClick,
}: {
  children?: React.ReactNode
  active?: boolean
  data: { label: string; value: string }
  onClick: (data: { label: string; value: string }) => void
}) {
  return (
    <div
      className={cn(
        'h-8 px-2.5 border border-secondary/30 grid place-items-center rounded-lg cursor-pointer transition-colors',
        active ? 'bg-primary border-0 text-white' : 'font-bold'
      )}
      onClick={() => onClick(data)}
    >
      {children}
    </div>
  )
}

function getOptions(data: ArticleFilter) {
  const tagsOptions = map(data.tag, (value, key) => ({
    label: value,
    value: key,
  }))
  return { tagsOptions }
}
